import { render, staticRenderFns } from "./UserComponentDynamic.vue?vue&type=template&id=05e7b192&scoped=true&"
import script from "./UserComponentDynamic.vue?vue&type=script&lang=js&"
export * from "./UserComponentDynamic.vue?vue&type=script&lang=js&"
import style0 from "./UserComponentDynamic.vue?vue&type=style&index=0&id=05e7b192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e7b192",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VIcon,VImg,VRow})
